var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('homepage-nav'),_c('v-content',[_c('jumbotron-banner'),_c('about-section'),_c('price-list'),_c('faq-section'),_c('contact-section')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }